import { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import pdfIcon from "../../assets/pdf.svg";
import crossIcon from "../../assets/cross.svg";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Typography } from "@mui/material";
import CardBox from "./CardBox";

export function SinglePDFDropzone(props: {
  uploadedFile: File | null;
  setUploadedFile: (file: File | null) => void;
  onUpload?: (file: File) => void;
  sx?: React.CSSProperties;
  label?: string | React.ReactNode;
  height?: string;
  width?: string;
}) {
  const [isLoading, setIsLoading] = useState(false);
  const onDrop = useCallback((acceptedFiles: File[]) => {
    setIsLoading(true);

    props.setUploadedFile(acceptedFiles[0]);
    if (props.onUpload) {
      props.onUpload(acceptedFiles[0]);
    }
    setIsLoading(false);
  }, []);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: {
      "application/pdf": [".pdf"],
    },
    multiple: false,
    onDrop,
  });
  const sx = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    text: "center",
    height: props.height,
    width: props.width,
    fontSize: "12px",
    ...props.sx,
  };
  return (
    <>
      {isLoading ? (
        <Box sx={{ ...sx }}>
          <FontAwesomeIcon icon={faSpinner} spin />
        </Box>
      ) : (
        <>
          {props.uploadedFile ? (
            <CardBox>
              <Box
                sx={{
                  ...sx,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-evenly",
                }}
              >
                Arquivo selecionado:
                <Box className="d-flex justify-content-around">
                  <img
                    width={30}
                    height={30}
                    src={pdfIcon}
                    className="rounded"
                    alt="pdf"
                  />
                  <Box style={{ maxWidth: "300px" }}>
                    <Typography
                      sx={{
                        overflow: "hidden",
                        fontSize: ".875rem",
                      }}
                    >
                      {props.uploadedFile.name}
                    </Typography>
                  </Box>
                  {!props.onUpload && (
                    <img
                      style={{ cursor: "pointer" }}
                      width={20}
                      height={20}
                      src={crossIcon}
                      className="rounded"
                      alt="pdf"
                      onClick={() => {
                        props.setUploadedFile(null);
                      }}
                    />
                  )}
                </Box>
              </Box>
            </CardBox>
          ) : (
            <CardBox
              sx={{ ...sx, cursor: "pointer" }}
              {...getRootProps({
                className: "dropzone ",
              })}
            >
              <Box>
                <>
                  {isDragActive ? (
                    <Typography sx={{ fontSize: "1rem" }}>
                      Solte o arquivo aqui
                    </Typography>
                  ) : (
                    <Typography sx={{ fontSize: "1rem" }}>
                      {props.label ||
                        "Arraste o arquivo aqui, ou clique para selecionar"}
                    </Typography>
                  )}
                  <input accept="pdf" {...getInputProps()} />
                </>
              </Box>
            </CardBox>
          )}
        </>
      )}
    </>
  );
}
